import React from "react";
import "./AccountDeleteStep.scss";
import remote from "../remote.png";

const AccountDeleteStep = () => {
  return (
    <div className="account-delete-container">
      <h2>How to Delete My Account</h2>
      <div style={{ width: "50%" }}>
        <p>
          Deleting the account will result in your mobile number, email address,
          and profile name being deleted from the platform and makes all other
          attributes related to your TV APP account anonymous so it is no longer
          associated with your phone number.
        </p>
        <p>
          If you want to delete your account from the Tv platform, please follow
          the steps below:
        </p>

        <div style={{ display: "flex" }}>
          <div className="app-steps">
            <h3>iOS / Android App:</h3>
            <ol>
              <li>Log in to your Signage play App account</li>
              <li>Login User</li>
              <li>Clikc on remote right button end open drawer</li>
              <li>Select Delete My Account End Clikc OK Button</li>
              <li>Click on ‘Yes to Delete Account’</li>
              <li>
                Your account deletion will be completed in a maximum of 30 days
              </li>
            </ol>
          </div>
          <img src={remote} style={{ width: "200px", height: "350px" }} />
        </div>

        <div className="website-steps">
          <h3>Website:</h3>
          <ol>
            <li>
              Log in to your Signage play App account with your phone number,
              email address, and OTP
            </li>
            <li>
              Contact us via available options at the bottom of this page and
              submit your request
            </li>
          </ol>
        </div>

        <div className="note">
          <h4>Things to Note Before Deleting Your Account:</h4>
          <ul>
            <li>Account deletion will take a maximum of 30 days.</li>
            <li>
              Once the account is deleted, you will not be able to recover it.
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default AccountDeleteStep;
